module.exports = __webpack_public_path__ + "static/media/icon.0a8befc9.png";